<template>
  <div class="cont">
    <el-dialog 
      :append-to-body='true'
      @close='handleClose'
      :title="dialogtitle" 
      :visible.sync="dialogVisibleData"  width="513px" center>
      <div v-if="curStatus == 1">
        <div   
          v-for=" ( item , index ) in beforeAutoParams " :key='index' 
        >
          <div style="display:flex;align-items:center;margin-bottom:13px;cursor : pointer" 
            @click="beforeKaqianClick( index , item.paramValueId , item.paramTypeId , item.paramValue )"
          >
            <div style="border-radius:50%;height:18px;width:18px;border:2px solid #7b7b7b"></div>
            <div style="font-size: 18px;font-weight: 700;color: #333333;margin-left:10px;margin-right:20px"> {{ item.paramValue }} </div>
            <el-image
              style="width: 222px; height: 168px"
              :src=' item.paramImage '
              fit="contain"
            ></el-image>
          </div>

        </div>
      </div>
      <div v-if="curStatus == 2">
        <div   
          v-for=" ( item , index ) in afterAutoParams " :key='index' 
        >
          <div style="display:flex;align-items:center;margin-bottom:13px;cursor : pointer" 
            @click="afterKaqianClick( index , item.paramValueId , item.paramTypeId , item.paramValue )"
          >
            <div style="border-radius:50%;height:18px;width:18px;border:2px solid #7b7b7b"></div>
            <div style="font-size: 18px;font-weight: 700;color: #333333;margin-left:10px;margin-right:20px"> {{ item.paramValue }} </div>
            <el-image
              style="width: 222px; height: 168px"
              :src=' item.paramImage '
              fit="contain"
            ></el-image>
          </div>

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogtitle: {
        type: String,
        default: ''
        // require: true // 必填
    },
    dialogVisible : {
      type: Boolean,
      default : false  ,
      
    },
    curStatus : {
      type: Number , 
      default : 0 
    },
    beforeAutoParams : {
      type: Array , 
      default : function () {
        return []
      }
    },
    afterAutoParams : {
      type: Array,
      default : function () {
        return []
      }
    }
  } ,
  data(){
    return {
      dialogVisibleData : this.dialogVisible
    }
  },
  methods : {
    //前卡钳点击
    beforeKaqianClick(index ,  paramValueId , paramTypeId,beforeParamValue ){

      if( this.afterAutoParams.length > 0 ){  //后卡钳可以点击
        this.$emit('update:curStatus', 2)
        this.$emit('update:dialogtitle', '请选择后卡钳类型')
        this.$emit('sendChild1', {
          beforeParamValueId : paramValueId ? paramValueId : '' ,
          beforeParamTypeId : paramTypeId ? paramTypeId : '' , 
          beforeParamValue: beforeParamValue ? beforeParamValue : '' ,
        })

      }else { //不能
        this.$emit('sendChild1', {
          beforeParamValueId : paramValueId ? paramValueId : '' ,
          beforeParamTypeId : paramTypeId ? paramTypeId : '' ,
          beforeParamValue : beforeParamValue ? beforeParamValue : '' ,
          getItems : true ,
        })
        // this.getItems()
      }

    },
    //后卡钳点击
    afterKaqianClick( index ,  paramValueId , paramTypeId,afterParamValue ){
      // console.log( index )  //giveChild2
      this.afterParamValueId = paramValueId ? paramValueId : ''
      this.afterParamTypeId = paramTypeId ? paramTypeId : ''
      this.afterParamValue = afterParamValue ? afterParamValue : ''

      this.$emit('update:curStatus', 0)
      this.$emit('update:dialogtitle', '')
      this.$emit('sendChild2', {
        afterParamValueId : paramValueId ? paramValueId : '' ,
        afterParamTypeId : paramTypeId ? paramTypeId : '' ,
        afterParamValue : afterParamValue ? afterParamValue : '' ,
      })
    },
    handleClose(){
      this.$emit('update:dialogVisible', false )
    }
  } ,
  watch:{
    dialogVisible(){
      this.dialogVisibleData = this.dialogVisible
    }
  }
}
</script>

